import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Data } from '@angular/router';
import {Observable} from 'rxjs/Observable'
import { AuthServiceService } from '../service/auth-service.service';

@Injectable()
export class AuthorizeUserService {

  constructor(private authService: AuthServiceService, private router: Router) {}
    canActivate(
      route: ActivatedRouteSnapshot,
      state: RouterStateSnapshot
    ): Observable<boolean>|Promise<boolean>|boolean {  
          const allowedModule : string = route.data['allowedModule'] || false;
         if (!this.authService.isAuthorized(allowedModule)) {
            this.router.navigate(['main/notauthorized']);
         }
        return true;
      
    }

}



// WEBPACK FOOTER //
// ./src/app/component/shared/authorize-user.service.ts